import { render, staticRenderFns } from "./CheckInOutApprovalDetail.vue?vue&type=template&id=98b0da70&scoped=true"
import script from "./CheckInOutApprovalDetail.vue?vue&type=script&lang=js"
export * from "./CheckInOutApprovalDetail.vue?vue&type=script&lang=js"
import style0 from "./CheckInOutApprovalDetail.vue?vue&type=style&index=0&id=98b0da70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b0da70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VTextField})
